import { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col, Card, Alert } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function UpdateProduct() {
  const { productId } = useParams();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (productId) {
      // Fetch product details
      fetch(`http://localhost:4000/products/${productId}`)
        .then((res) => res.json())
        .then((data) => {
          if (data) {
            setName(data.name);
            setDescription(data.description);
            setPrice(data.price);
            setLoading(false);
          } else {
            setError("Product not found");
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching product:", error);
          setError("Failed to load product details");
          setLoading(false);
        });
    }
  }, [productId]);

  const updateProduct = (e) => {
    e.preventDefault();

    fetch(`http://localhost:4000/products/edit/${productId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        name: name,
        description: description,
        price: parseFloat(price),
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === true) {
          Swal.fire({
            title: "Product Updated!",
            icon: "success",
            text: "Product has been successfully updated!",
          }).then(() => {
            navigate("/admin");
          });
        } else {
          Swal.fire({
            title: "Update Failed",
            icon: "error",
            text: "Failed to update product. Please try again.",
          });
        }
      })
      .catch((error) => {
        console.error("Error updating product:", error);
        Swal.fire({
          title: "Error",
          icon: "error",
          text: "Failed to connect to server.",
        });
      });
  };

  if (loading) {
    return (
      <Container className="mt-5">
        <Alert variant="info">Loading product details...</Alert>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
        <Button variant="secondary" onClick={() => navigate("/admin")}>
          Back to Admin
        </Button>
      </Container>
    );
  }

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card>
            <Card.Header>
              <h3 className="mb-0">Update Product</h3>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={updateProduct}>
                <Form.Group className="mb-3">
                  <Form.Label>Product Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter product name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    placeholder="Enter product description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Price (₱)</Form.Label>
                  <Form.Control
                    type="number"
                    step="0.01"
                    min="0"
                    placeholder="Enter price"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    required
                  />
                </Form.Group>

                <div className="d-flex justify-content-between">
                  <Button
                    variant="secondary"
                    onClick={() => navigate("/admin")}
                  >
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit">
                    Update Product
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}